import script from "./HeaderCom.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderCom.vue?vue&type=script&setup=true&lang=js"

import "./HeaderCom.vue?vue&type=style&index=0&id=21f0412c&scoped=true&lang=scss"
import "./HeaderCom.vue?vue&type=style&index=1&id=21f0412c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21f0412c"]])

export default __exports__